import Image from 'next/image';
import { SplashFlexWrapper } from './styled';

const SplashLoader = ({ message }) => (
  <SplashFlexWrapper className="splash-flex-wrapper">
    <div className="wrapper">
      <div className="lds-ring">
        <div />
        <div />
        <div />
        <div />
      </div>
      <div className="image-wrapper">
        <Image src="/static/favicons/pollme_fav.png" alt="google social" width={56} height={56} />
      </div>
    </div>
    {message && <div className="loading-message">{message}</div>}
  </SplashFlexWrapper>
);

export default SplashLoader;
